import __vue_component__$2 from '../HseIcon/HseIcon.vue.js';
import { computeVisibleTags } from '@hse-design/core';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Vue } from 'vue-property-decorator';
import __vue_component__$3 from '../HseClickableIcon/HseClickableIcon.vue.js';
import __vue_component__$1 from '../../icons/action/arrow/dropdown/bottom/IconActionArrowDropdownBottom.vue.js';
import __vue_component__ from '../../icons/action/delete/IconActionDelete.vue.js';
import { colorGrayDusk } from '@hse-design/tokens';
import { SelectSize } from './types.js';
import __vue_component__$4 from './HseSelectTag.vue.js';

var HseSelectValueContainer = /** @class */ (function (_super) {
    __extends(HseSelectValueContainer, _super);
    function HseSelectValueContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tagsCount = Infinity;
        _this.tagsRightGap = 11;
        return _this;
    }
    Object.defineProperty(HseSelectValueContainer.prototype, "IconActionDelete", {
        get: function () {
            return __vue_component__;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelectValueContainer.prototype, "IconActionArrowDropdownBottom", {
        get: function () {
            return __vue_component__$1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelectValueContainer.prototype, "iconColor", {
        get: function () {
            return colorGrayDusk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelectValueContainer.prototype, "isNotAllTagsVisible", {
        get: function () {
            return this.selectedOptions.length > this.tagsCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelectValueContainer.prototype, "slicedOptions", {
        get: function () {
            return this.selectedOptions.slice(0, this.tagsCount);
        },
        enumerable: false,
        configurable: true
    });
    HseSelectValueContainer.prototype.mounted = function () {
        this.computeVisibleTags();
    };
    HseSelectValueContainer.prototype.updated = function () {
        this.computeVisibleTags();
    };
    HseSelectValueContainer.prototype.resetVisibleTags = function () {
        this.tagsCount = Infinity;
    };
    HseSelectValueContainer.prototype.computeVisibleTags = function () {
        var newCount = computeVisibleTags(this.$refs.multipleValues, this.tagsRightGap);
        if (newCount !== Infinity) {
            this.tagsCount = newCount;
        }
    };
    __decorate([
        Prop({
            default: function () { return ({}); }
        }),
        __metadata("design:type", Object)
    ], HseSelectValueContainer.prototype, "classes", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "showClearIcon", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "focused", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "disabled", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "selected", void 0);
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", Object)
    ], HseSelectValueContainer.prototype, "leftIcon", void 0);
    __decorate([
        Prop({ default: [] }),
        __metadata("design:type", Array)
    ], HseSelectValueContainer.prototype, "selectedOptions", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "showTags", void 0);
    __decorate([
        Prop({ default: -1 }),
        __metadata("design:type", Number)
    ], HseSelectValueContainer.prototype, "focusedTagI", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "showSelectedValueInField", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "showPlaceholderInField", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "showInputInValueField", void 0);
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", Object)
    ], HseSelectValueContainer.prototype, "singleValueLabel", void 0);
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", Object)
    ], HseSelectValueContainer.prototype, "placeholder", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "clearButtonFocused", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSelectValueContainer.prototype, "isOpen", void 0);
    __decorate([
        Prop({ default: SelectSize.medium }),
        __metadata("design:type", String)
    ], HseSelectValueContainer.prototype, "size", void 0);
    __decorate([
        Watch('selectedOptions'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HseSelectValueContainer.prototype, "resetVisibleTags", null);
    HseSelectValueContainer = __decorate([
        Component({
            name: 'HseSelectValueContainer',
            components: {
                HseIcon: __vue_component__$2,
                HseClickableIcon: __vue_component__$3,
                HseSelectTag: __vue_component__$4
            }
        })
    ], HseSelectValueContainer);
    return HseSelectValueContainer;
}(Vue));

export default HseSelectValueContainer;
